
























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { client } from '@/store';
import { capitalize } from '../utils';
import { IUser, Maybe, ICRUDResponse } from '../models';
import { Action } from 'vuex-class';

const ComponentMap: Record<string, () => unknown> = {
  file: () => import(`@/views/File/FilePreview.vue`),
} as const;
const specialHandlers = {};

@Component
export default class EntityPicker<
  T extends { id: number; name?: string }
> extends Vue {
  @Prop(String) readonly label: string;
  @Prop(String) readonly type: string;
  @Prop() readonly value?: T | T[];
  @Prop() readonly url?: string;
  @Prop(Boolean) readonly readonly?: boolean;
  @Prop({ default: false }) readonly large: boolean;
  @Prop({ default: false }) readonly multiple: boolean | string;
  @Prop({ default: () => ({}) }) readonly entityPatch: Partial<T>;
  @Prop({ default: () => undefined }) readonly change: (
    a1: T | T[] | number[],
  ) => void;
  @Prop({ default: (entity: T) => entity?.name || '' }) readonly textSelector: (
    a1: T,
  ) => string;
  @Action('uploadFiles', { namespace: 'file' }) uploadFiles: (
    files: FileList,
  ) => Promise<T[]>;
  modal = false;
  items: T[] = [];
  searchString = '';
  modalType = 'Detail';
  multiId: Maybe<number> = null;
  onPrependClick() {
    if (this.type === 'file' && this.multiple === '' && !this.readonly) {
      // @ts-ignore
      this.$refs.fileuploader.click();
      return;
    }
    this.openModal();
  }
  // @ts-ignore
  onInputChange(value) {
    if (!this.readonly) this.change(value);
  }
  openModal() {
    this.modal = true;
    this.multiId = null;
  }
  openModalMulti(id: number) {
    this.multiId = id;
    this.modal = true;
  }
  removeItem(idx: number) {
    // @ts-ignore
    const values = this.value.filter((item) => {
      if (typeof item === 'object') {
        return item.id !== idx;
      } else {
        return item !== idx;
      }
    });
    // @ts-ignore
    this.change(values.flatMap((item) => item.id || item));
  }
  onCreate({ entity, redirect }: { entity: T; redirect: boolean }) {
    if (redirect) {
      this.modal = false;
    }
    this.items.push(entity);

    if (this.multiple === '') {
      const items = this.flatValue ? (this.flatValue as number[]) : [];
      // @ts-ignore
      this.change([...items, entity.id]);
    } else {
      this.change(entity);
    }
  }
  onChange({ entity }: { entity: T }) {
    this.modal = false;
    const index = this.items.findIndex(({ id }) => {
      return id === entity.id;
    });
    if (index > -1) Vue.set(this.items, index, entity);
    if (this.multiple === '') {
      if (!Array.isArray(this.value)) return;
      this.change(
        // @ts-ignore
        this.flatValue.map((item) => (entity.id === item ? entity.id : item)),
      );
    } else {
      this.change(entity);
    }
  }
  onClose() {
    this.modal = false;
    this.multiId = null;
  }
  onFileInputChange() {
    const input = this.$refs.fileuploader as HTMLInputElement;
    this.uploadFiles(input.files!).then((files) => {
      this.items = [...this.items, ...files];
      this.change(
        [...this.flatValue, ...files].flatMap((item) =>
          typeof item === 'object' ? item.id : item,
        ),
      );
    });
    input.value = '';
  }
  @Watch('value', { immediate: true, deep: true })
  onChangeValue() {
    if (Array.isArray(this.value) && this.value.length) this.getItems();
  }
  @Watch('searchString')
  onSearch(search?: string) {
    if (!search || search.length < 3) {
      this.items = [];
    } else {
      this.getItems(search);
    }
  }
  getItems(search?: string) {
    return client
      .get<ICRUDResponse<T[]>>(`nomenclature/${this.type}`, {
        params: {
          // @ts-ignore-next-line
          ids: this.flatValue.join(','),
          search,
        },
      })
      .then(({ data: { data } }) => (this.items = data));
  }
  get flatValue() {
    if (Array.isArray(this.value)) {
      return this.value.map((item) =>
        typeof item === 'object' ? item.id : item,
      );
    } else return [];
  }
  get component() {
    if (this.type === 'file' && this.multiple === '' && this.multiId) {
      return ComponentMap[this.type];
    }
    const path = this.type.replace(/_\w/, (match) => {
      return match[1].toUpperCase();
    });
    return () =>
      import(
        `@/views/${capitalize(path)}/${capitalize(path)}${this.modalType}.vue`
      );
  }
  get prependIcon() {
    return this.multiple === ''
      ? 'mdi-plus'
      : this.value
      ? 'mdi-pencil'
      : 'mdi-plus';
  }
}
